export enum RewardPolicyEnum {
  ADD_CREDIT_CARD = '100',
  LOAD_WALLET_MIN_AMOUNT = '101',
  ADD_BIRTHDAY = '102',
  AUTO_RELOAD = '103',
  APP_SURVEY = '104',
  PURCHASE_STREAK = '105',
  COME_BACK_SOON = '106',
  MIN_SPEND = '107',
  ADD_PHONE_NUMBER = '108',
};
